import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../../../../../../../../../../components/CiscoUi';
import UserRoleGuard from '../../../../../../../../../../../../auth/components/UserRoleGuard/container.ts';
import { REQUIRED_ROLES_FOR_SHOW_DISABLED_TEMPLATES_FILTER } from './constants.ts';

export type IncludeGseOnlyTemplatesFilterProps = {
  areGseOnlyTemplatesIncluded: boolean;
  onChange: VoidFunction;
};

export const IncludeGseOnlyTemplatesFilter = ({
  areGseOnlyTemplatesIncluded,
  onChange,
}: IncludeGseOnlyTemplatesFilterProps) => {
  const { t } = useTranslation();

  return (
    <UserRoleGuard
      requiredRoles={REQUIRED_ROLES_FOR_SHOW_DISABLED_TEMPLATES_FILTER}
    >
      <Checkbox
        checked={areGseOnlyTemplatesIncluded}
        label={t(
          'virtualMachines.add.filters.vmTemplates.includeGseOnlyTemplates',
        )}
        onChange={onChange}
        name="vm-templates-filter-toggle"
      />
    </UserRoleGuard>
  );
};
